import React from 'react'
import { Box, Typography } from '@mui/material'
import { WarningTwoTone } from '@mui/icons-material'
import makeStyles from '@mui/styles/makeStyles'
import { useTranslation } from '../../hooks'

const useStyles = makeStyles(({ breakpoints, palette, spacing, typography }) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: spacing(2),
    gap: spacing(2),
    marginBottom: spacing(2),
    backgroundColor: '#FEFCFF',
    border: '1px solid #DDDBE0',
    borderRadius: spacing(1)
  }
}))

const SkillBitesTrialWarningBanner = () => {
  const classes = useStyles()
  const { t } = useTranslation('skill_bite')

  return (
    <Box className={classes.root} data-test='skill-bites-trial-banner'>
      <Box data-test='skill-bites-trial-banner-icon'>
        <WarningTwoTone fontSize='large' color='primary' />
      </Box>
      <Box>
        <Typography variant='h6' data-test='skill-bites-trial-banner-title'>
          {t('trial_banner_title')}
        </Typography>
        <Typography variant='body2' data-test='skill-bites-trial-banner-description'>
          {t('trial_banner_description')}
        </Typography>
      </Box>
    </Box>
  )
}

export default SkillBitesTrialWarningBanner
